import { Component } from '@angular/core';
import { membersuiteLateFeeProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Late Fee Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitelatefeeproduct-form',
    templateUrl: './membersuitelatefeeproduct.form.component.html'
})
export class membersuiteLateFeeProductFormComponent extends BaseFormComponent {
    public record!: membersuiteLateFeeProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

